import { useCallback } from 'react'

const useParentPostMessage = () => {
  const postMessage = useCallback((message?: unknown, targetOrigin = '*') => {
    try {
      window?.parent.postMessage(message, targetOrigin)
    } catch (error) {
      if (error instanceof Error) {
        console.log(error.message)
      }

      console.log(error)
    }
  }, [])

  return { postMessage }
}

export default useParentPostMessage
